import { mdiDownload, mdiSelectAll, mdiSelectOff, mdiTrashCan } from '@mdi/js'
import Icon from '@mdi/react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import * as React from 'react'
import styles from './FileFolderViewHeader.pcss'

export interface FilesBulkActionsProps {
  allSelected: boolean
  disabled: boolean
  className?: string
  onDelete: () => void
  onDownload: () => void
  onToggleAllSelected: () => void
}

export function FilesBulkActions({
  allSelected,
  className,
  disabled,
  onDownload,
  onDelete,
  onToggleAllSelected
}: FilesBulkActionsProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const closeMenu = () => {
    setAnchorEl(null)
  }

  const handleDelete = () => {
    onDelete()
    closeMenu()
  }

  const handleDownload = () => {
    onDownload()
    closeMenu()
  }

  const handleToggleAllSelected = () => {
    onToggleAllSelected()
    closeMenu()
  }

  return (
    <div className={`${styles['bulk-actions-box']} ${className || ''}`} data-testid="files-bulk-actions">
      <Button disabled={disabled} data-testid="btn-menu-trigger" onClick={openMenu}>Bulk actions</Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        classes={{ paper: styles.menu }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        onClose={closeMenu}
      >
        <MenuItem onClick={handleToggleAllSelected}><Icon path={allSelected ? mdiSelectOff : mdiSelectAll} size="20px" />
          {allSelected ? 'Deselect all' : 'Select all'}
        </MenuItem>
        <MenuItem onClick={handleDownload}><Icon path={mdiDownload} size="20px" />
          Download links of selected
        </MenuItem>
        <MenuItem onClick={handleDelete}><Icon path={mdiTrashCan} size="20px" />
          {`Delete ${allSelected ? 'all' : 'selected'} files`}
        </MenuItem>
      </Menu>
    </div>
  )
}
